<template>
  <!-- 渲染预览
      @author liuguisheng
      @date 2019-9-14  
   -->
  <div class="rice-preview_render"
       :style="{width: currentRenderWidth}">
    <!-- 骨架屏组件 -->
    <skeleton :loading="renderLoading"
              :row="10"></skeleton>
    <div v-show="!renderLoading">
      <template v-if="itemManage==='group'">
        <render-item-template v-for="(item) in domainNodeList"
                              :key="item.id"
                              :formNode="item"
                              @hook:mounted="renderMounted">
        </render-item-template>
      </template>
      <render-item-template v-for="(item) in formList"
                            :key="item.id"
                            :formNode="item"
                            @hook:mounted="renderMounted">
      </render-item-template>
    </div>
  </div>
</template>

<script>
/** 混入方法 ::: 
 *  @mixin mixRicePreviewRenderStore 表单预览组件混入
 */
import { mixRicePreviewRenderStore } from "@/mixins/rice_preview_render/mix_rice_preview_render.js";
/** 工具方法 :::
 *  @function deepCopy 深拷贝方法
 *  @function upgrade 配置升级方法
 */
import { deepCopy } from "@/utils/utils.js";
import { upgrade } from "@/assets/version/version.js";


export default {
  name: 'RicePreviewRender',
  mixins: [ mixRicePreviewRenderStore ],
  model: {
    prop: "formModel",
    event: "refurbishModel",
  },
  props: {
    // 接收的表单项model集合
    formModel: {
      type: Object,
      default: () => ({})
    },
    // 接收的表单数据
    formData: {
      type: Object,
      default: () => ({})
    },
    // 渲染的宽度
    renderWidth: {
      type: Number,
      default: 1000
    },
    // 滚动到指定位置
    scrollPosition: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      itemManage: 'none',       // 模版类型  { 'group':启用分组的模版 }
      renderLoading: true
    }
  },
  computed: {
    /** @name 模块组件节点列表
     *  @return {Array} 模块节点列表
     *  @author 王汝鹏
     *  @version 2019-12-27
     */
    domainNodeList() {
      return this.domainList.map(domain => this.domainManager(domain).getNode());
    },
    /** @name 渲染的宽度计算
     *  @return { String }
     *  @author liuguisheng
     *  @version 2019-12-20
     */
    currentRenderWidth () {
      return `${this.renderWidth}px`
    },
  },
  methods: {
    /** @name 获取html元素距离浏览器窗口顶部距离
     *  @description 因为offsetTop只能获取元素相对于父级元素顶部的距离所以需要递归的进行计算
     *  @param {Element} element html元素
     *  @return {Number} 元素距离顶部距离
     *  @author 王汝鹏
     *  @version 2020-01-17
     */
    getElementTop(element) {
      let actualTop = element.offsetTop;
      let current = element.offsetParent;

      while (current !== null) {
        actualTop += current.offsetTop;
        current = current.offsetParent;
      }
      return actualTop;
　　},
    /** @name 滚动到指定元素位置 
     *  @param {String} formId 表单项id
     *  @author 王汝鹏
     *  @version 2020-01-17
     */
    scrollToForm(formId) {
      let currentElementTop = this.getElementTop(this.$el);
      let renders = this.$el.getElementsByClassName(formId);

      if (renders.length > 0) {
        let oldDisplay = renders[0].style.display;
        renders[0].style.display="inline-block";

        let scrollTo = this.getElementTop(renders[0]);
        this.$el.scrollTo(0, scrollTo - currentElementTop);

        renders[0].style.display=oldDisplay;
      }
    },
    /**
    * @name 渲染加载完毕
    * @description 
    * @params {}
    * @return { void }
    * @author liuguisheng
    * @version 2020-08-11 11:25:59 星期二
    */
    renderMounted () {
      setTimeout(() => { this.renderLoading = false },  1000);
    }
  },
  watch: {
    /** @name 表单填写数据
     *  @param {Object} newValue 更新后的表单
     *  @author 王汝鹏
     *  @version 2019-11-09
     */
    formModel: {
      handler(newValue) { this.formModels = newValue; },
      immediate: true
    },
    /** @name 表单项数据
     *  @param {Object} newValue 更新后的数据
     *  @author 王汝鹏
     *  @version 2019-11-11
     */
    formData: {
      handler(newValue) {
        let upgradeValue = {};
        try {
          upgradeValue = upgrade(newValue);
          //  更新store数据
          this.importTemplateConfig(upgradeValue);
          // console.log('配置升级:: ', formData, upgradeValue);
        } catch(error) {
          // console.log("配置升级错误:: ",  formData);
        }
      },
      immediate: true
    },
    /** @name 滚动到指定元素的位置
     *  @param {Object} newValue 更新后的数据
     *  @author 王汝鹏
     *  @version 2020-01-17
     */
    scrollPosition: {
      handler(newValue) {
        if (newValue && /id-\w+/.test(newValue)) { this.scrollToForm(newValue); }
      }
    }
  }
}
</script>
<style lang="scss">
@import "../../../src/style/index.scss";
</style>



// WEBPACK FOOTER //
// packages/RicePreviewRender/src/RicePreviewRender.vue